/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
import React, { useRef, useState, useEffect, useCallback } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { Popup } from '@progress/kendo-react-popup';
import Loader, { LoaderSizes } from '../Loader';
import './styles.scss';
import '../../Select/Select.scss';
export default function PaginatedSelect({ id, className, optionRenderer, valueRenderer, options, label, placeholder = 'Select an option...', value, onChange, onSearch, onLoadMore, hasMore = false, isLoading = false, isLoadingMore = false, searchable = true, variant = 'inline' }) {
    const [visible, setVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const listRef = useRef(null);
    const searchInputRef = useRef(null);
    const anchor = useRef(null);
    // Handle search with debouncing
    useEffect(() => {
        if (!onSearch)
            return;
        const timeoutId = setTimeout(() => {
            onSearch(searchTerm);
        }, 300);
        return () => clearTimeout(timeoutId);
    }, [searchTerm, onSearch]);
    // Handle infinite scroll
    const handleScroll = useCallback(() => {
        if (!listRef.current || !hasMore || isLoadingMore)
            return;
        const { scrollTop, scrollHeight, clientHeight } = listRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 5) {
            onLoadMore === null || onLoadMore === void 0 ? void 0 : onLoadMore();
        }
    }, [hasMore, isLoadingMore, onLoadMore]);
    // Focus search input when dropdown opens
    useEffect(() => {
        if (visible && searchable && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [visible, searchable]);
    const handleOpen = () => {
        setVisible(true);
        setSearchTerm('');
    };
    const handleClose = () => {
        setVisible(false);
        setSearchTerm('');
    };
    const selectedOption = options.find((option) => option.value === value);
    const displayValue = (valueRenderer === null || valueRenderer === void 0 ? void 0 : valueRenderer(value)) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || placeholder;
    return (React.createElement("div", { className: className ? `${className} selectContainer` : 'selectContainer' },
        variant === 'inline' && (React.createElement("button", { type: "button", className: "qmb-control--menu content-actions__toggle", onClick: handleOpen, ref: anchor },
            label ? React.createElement(React.Fragment, null,
                label,
                ": ") : '',
            React.createElement("span", { className: "selectValue" }, displayValue))),
        variant === 'dropdown' && (React.createElement("div", { className: "qmb-select--x-full selectContainer" },
            React.createElement("select", { id: id, ref: anchor, "aria-label": "Select", onClick: (e) => {
                    e.preventDefault();
                    handleOpen();
                }, onChange: (e) => {
                    e.preventDefault();
                }, value: displayValue || '' },
                React.createElement("option", { value: "", disabled: true }, placeholder),
                selectedOption && React.createElement("option", { value: selectedOption.value }, displayValue)),
            React.createElement("label", { htmlFor: id, className: "qmb-label" }, label))),
        React.createElement(Popup, { anchor: anchor.current, show: visible, onClose: handleClose },
            React.createElement(ClickAwayListener, { onClickAway: handleClose, onKeyDown: (e) => {
                    if (e.key === 'Escape') {
                        handleClose();
                    }
                } },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list paginatedSelect" },
                    searchable && (React.createElement("div", { className: "searchContainer" },
                        React.createElement("input", { ref: searchInputRef, type: "text", placeholder: "Search...", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), className: "searchInput" }))),
                    isLoading ? (React.createElement("div", { className: "loadingContainer" },
                        React.createElement(Loader, { size: LoaderSizes.small }))) : (React.createElement("ul", { role: "presentation", ref: listRef, onScroll: handleScroll, className: "optionsList" },
                        options.map((option) => (optionRenderer === null || optionRenderer === void 0 ? void 0 : optionRenderer(option)) || (React.createElement("li", { key: option.value, role: "presentation" },
                            React.createElement("button", { type: "button", onClick: () => {
                                    onChange(option.value);
                                    handleClose();
                                } }, option.label)))),
                        isLoadingMore && (React.createElement("li", { className: "loadingMore" },
                            React.createElement(Loader, { size: LoaderSizes.small }),
                            React.createElement("span", null, "Loading more..."))),
                        !hasMore && options.length > 0 && (React.createElement("li", { className: "noMoreOptions" },
                            React.createElement("span", null, "No more options"))),
                        options.length === 0 && !isLoading && (React.createElement("li", { className: "noOptions" },
                            React.createElement("span", null, "No options found"))))))))));
}
